import { Trans, useLingui } from '@lingui/react/macro';

import Paragraph from '@/design_system/Typography/Paragraph';
import IconUserMail from '@/icons/UserMail.svg';
import { CONTACT_METHOD_OPTIONS } from '@/routes/Requests/Request/Article/components/ArticleActions/shared/RecordClientContactDialog';
import { formatDate } from '@/utils/date';

import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityDetailedContent,
  BaseActivityText,
} from './BaseActivity/BaseActivity';
import { ActivityOfType } from './Activity';

export const ClientContactRecordedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'client_contact_recorded'>;
  displayArticleName: boolean;
}) => {
  const { i18n } = useLingui();

  const creatorName = activity.data?.salesAdvisor
    ? `${activity.creator.name} (${activity.data.salesAdvisor})`
    : activity.creator.name;

  const contactDate = activity.data
    ? formatDate(new Date(activity.data.contactedAt), { dateStyle: 'medium' })
    : '';

  const contactMethodOption = CONTACT_METHOD_OPTIONS.find(
    (option) => option.id === activity.data?.contactMethod
  );
  const contactMethod = contactMethodOption ? i18n._(contactMethodOption.label) : undefined;

  const articleName = (
    <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
  );

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="neutral"
      icon={<IconUserMail />}
      message={
        <BaseActivityText>
          {displayArticleName ? (
            <Trans id="activities.client_contact_recorded.text.with-item">
              <strong>{creatorName}</strong> recorded a client outreach about the item {articleName}{' '}
              on {contactDate} ({contactMethod})
            </Trans>
          ) : (
            <Trans id="activities.client_contact_recorded.text">
              <strong>{creatorName}</strong> recorded a client outreach on {contactDate} (
              {contactMethod})
            </Trans>
          )}
        </BaseActivityText>
      }
    >
      {!!activity.data?.additionalInformation && (
        <BaseActivityDetailedContent>
          <Paragraph size="200" color="secondary">
            {activity.data?.additionalInformation}
          </Paragraph>
        </BaseActivityDetailedContent>
      )}
    </BaseActivity>
  );
};
